/**
 * @Description 创建机会点-周边门店信息-tab
 */

import V2Tabs from '@/common/components/Data/V2Tabs';
import ButtonTabs from '@/common/components/Tabs/ButtonTabs';
import { useEffect, useState } from 'react';
import styles from './index.module.less';
import { useMethods } from '@lhb/hook';
import { isNotEmptyAny } from '@lhb/func';
import { useBigdataFn } from '@/common/utils/bigdata';

const StoreInfoTab = ({
  currentIndex,
  setCurrentIndex,
  currentSecondIndex,
  setCurrentSecondIndex,
  tabOptions,
  tableFilter,
  setTableFilter,
  setCurDetail,
}) => {
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [firstData, setFirstData] = useState<any>([]); // 一级分类tab list
  const [secondData, setSecondData] = useState<any>([]); // 二级分类tab list

  useEffect(() => {
    if (tabOptions?.length) {
      methods.getTabData();
    }
  }, [tabOptions]);

  const methods = useMethods({
    /**
     * @description 获取tab list
     */
    getTabData() {
      const _firstData = tabOptions?.map((item) => ({
        label: `${item.name}${isNotEmptyAny(item.poiNum) ? ` ${item.poiNum}` : ''}`,
        key: item.code,
        child: item.children,
      }));
      setFirstData(_firstData);
      setCurrentIndex(_firstData[0]?.key || null);
      if (_firstData[0]?.child?.length) {
        const _secondData = _firstData[0].child?.map((item) => ({
          label: `${item.name}${isNotEmptyAny(item.poiNum) ? ` ${item.poiNum}` : ''}`,
          key: item.code,
          num: item.poiNum,
        }));
        const hideSecondData = (_secondData[0]?.key === 'FAMOUS_BRAND' && !_secondData[0]?.num);
        setSecondData(hideSecondData ? [] : _secondData);
        setCurrentSecondIndex(_secondData[0]?.key || null);
        setTableFilter({ ...tableFilter, poiType: _secondData[0]?.key });
      } else {
        setSecondData([]);
        setCurrentSecondIndex(null);
        setTableFilter({ ...tableFilter, poiType: _firstData[0]?.key });
      }
    },
    /**
     * @description 一级分类tabChange
     */
    onFirstChange(key: string) {
      setCurrentIndex(key);
      setCurDetail({});
      const currentItem = firstData.find((item) => item.key === key) || {};
      if (currentItem.child?.length) {
        const _secondData = currentItem.child.map((item) => ({
          label: `${item.name}${isNotEmptyAny(item.poiNum) ? ` ${item.poiNum}` : ''}`,
          key: item.code,
          num: item.poiNum,
        }));
        const hideSecondData = (_secondData[0]?.key === 'FAMOUS_BRAND' && !_secondData[0]?.num);
        setSecondData(hideSecondData ? [] : _secondData);
        setCurrentSecondIndex(_secondData[0]?.key || null);
        setTableFilter({ ...tableFilter, poiType: _secondData[0]?.key });
      } else {
        setSecondData([]);
        setCurrentSecondIndex(null);
        setTableFilter({ ...tableFilter, poiType: key });
      }
      bigdataFn('de48eaa1-e17f-4e0d-9f1f-66a38a4195f8', '经营门店一级TAB', '点击了经营门店一级TAB', { op_block: '', op_event: ``, });
    },
    /**
     * @description 二级分类tabChange
     */
    onSecondChange(key: string) {
      setCurrentSecondIndex(key);
      setCurDetail({});
      setTableFilter({ ...tableFilter, poiType: key });
    }
  });

  return (
    <>
      { !!firstData?.length && (
        <V2Tabs
          activeKey={currentIndex}
          items={firstData}
          className={styles['tabs']}
          onChange={methods.onFirstChange}/>
      ) }
      {!!secondData?.length && (
        <ButtonTabs
          activeKey={currentSecondIndex}
          items={secondData}
          className={styles['button-tab']}
          onChange={methods.onSecondChange}/>
      ) }
    </>
  );
};

export default StoreInfoTab;
